module.exports = __webpack_public_path__ + "static/media/logo3.1.b40affa5.png";